<template>
  <div class="ui-frame">
    <transition @enter="enterLogo" @leave="leaveLogo" appear>
      <div
        class="ui-frame__logo"
        :class="{ 'ui-frame__logo--app' : $inApp }"
        v-if="(isTouchDevice() && $store.state.mode === 'intro') || !isTouchDevice()"
      >
        <AppLogo />
      </div>
    </transition>

    <transition @enter="enterUi" @leave="leaveUi">
      <Intro
        class="ui-section"
        data-phase="intro"
        v-if="$store.state.mode === 'intro'"
      />

      <Tutorial
        class="ui-section"
        data-phase="tutorial"
        v-if="$store.state.mode === 'tutorial'"
      />

      <Game
        class="ui-section"
        data-phase="game"
        v-if="$store.state.mode === 'playing'"
      />

      <Pause
        class="ui-section"
        data-phase="pause"
        v-if="$store.state.mode === 'paused'"
      />

      <GameOver
        class="ui-section"
        data-phase="gameover"
        v-if="$store.state.mode === 'gameover'"
      />
    </transition>

    <ButtonCircular />
  </div>
</template>

<script>
import { gsap } from 'gsap';
import AppLogo from '@/components/AppLogo';
import ButtonCircular from '@/components/ButtonCircular';
import Intro from '@/components/UI/Intro';
import Tutorial from '@/components/UI/Tutorial';
import Game from '@/components/UI/Game';
import Pause from '@/components/UI/Pause';
import GameOver from '@/components/UI/GameOver';

import { isTouchDevice } from '@/scripts/utils';
import transition from '@/scripts/transitions';

export default {
  name: 'UIFrame',

  components: {
    AppLogo,
    ButtonCircular,
    Intro,
    Tutorial,
    Game,
    Pause,
    GameOver,
  },

  data() {
    return {
      isTouchDevice,
    };
  },

  mounted() {
    this.keydownHandler = (e) => this.keydown(e);
    window.addEventListener('keydown', this.keydownHandler);
  },

  methods: {
    enterUi(el, done) {
      const { phase } = el.dataset;
      if (phase === 'gameover') this.$sendEvent('End', 'game_over');

      transition.get(`${phase}-enter`)(el).then(done);
    },
    leaveUi(el, done) {
      const { phase } = el.dataset;
      transition.get(`${phase}-leave`)(el).then(() => {
        if (phase === 'tutorial') this.$eventHub.$emit('play');
        // If tutorial is already done sync with tutorial and play
        if (phase === 'intro' && this.$store.state.tutorialDone) {
          this.$eventHub.$emit('tutorial');
          setTimeout(() => { this.$eventHub.$emit('play'); }, 2000);
        }

        done();
      });
    },
    enterLogo(el, done) {
      gsap.to(el, {
        scale: 1,
        duration: 2,
        autoAlpha: 1,
        ease: 'elastic.out(0.5, 0.7)',
        onComplete: done,
      });
    },
    leaveLogo(el, done) {
      gsap.to(el, {
        scale: 0,
        duration: 0.5,
        autoAlpha: 0,
        transformOrigin: '50% 35%',
        ease: 'power3.easeOut',
        onComplete: done,
      });
    },
    keydown(e) {
      if (e.keyCode === 27 && (this.$store.state.mode === 'playing' || this.$store.state.mode === 'paused')) this.$eventHub.$emit(this.$store.state.mode === 'playing' ? 'pause' : 'resume');
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-frame {
  @include full(true);

  pointer-events: none;

  .ui-section {
    @include full(true);
  }

  &__logo {
    position: fixed;
    top: -5%;
    left: 50%;

    transform: translateX(-50%);

    &--app {
      z-index: 5;

      @include mq($until: mobileL) {
        top: -3.5%;
      }
    }
  }
}
</style>
